var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-398d562b-e6ff-4337-aeb5-11e64e31faba",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 959.04 918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-ac4d9b19-ef90-4431-ae12-479f186b55ec {\r\n\r\n        stroke: #454746;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 80px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-ac4d9b19-ef90-4431-ae12-479f186b55ec",
    d: "M473.78,705.92l-241.99,168.39c-15.63,10.88-36.21-4.08-30.7-22.3l85.37-282.19c1.22-4.02-.2-8.37-3.55-10.91L47.99,380.8c-15.18-11.51-7.31-35.7,11.73-36.09l294.76-6.01c4.2-.09,7.9-2.78,9.28-6.74L460.55,53.49c6.25-17.99,31.69-17.99,37.95,0l96.8,278.47c1.38,3.97,5.08,6.66,9.28,6.74l294.76,6.01c19.04.39,26.9,24.58,11.73,36.09l-234.93,178.11c-3.35,2.54-4.76,6.89-3.55,10.91l85.37,282.19c5.51,18.23-15.07,33.18-30.7,22.3l-241.99-168.39c-3.45-2.4-8.02-2.4-11.47,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.04ef223706bd218bc1831c6d7f3defdf.svg";
export { ForwardRef as ReactComponent };